import clsx from 'clsx'

import './style.scss'
import { type PropsWithChildren } from 'react'
import BottomLayerSVG from './BottomLayerSVG'

interface TalentCardPaperProps {
  className?: string
  isBackground?: boolean
  showLogo?: boolean
  onFlipCardClick?: () => void
}

const TalentCardPaper = ({ isBackground, className, children, onFlipCardClick }: PropsWithChildren<TalentCardPaperProps>) => {
  return (
        <div
            className={clsx(className, 'talentcard-paper', { 'talentcard-paper--is-background': isBackground })}
            onClick={onFlipCardClick}
        >
            {/* Bottom layer - background SVG */}
            <BottomLayerSVG className='talentcard-paper__background-bottom' />

            {/* Middle layer - participant content */}
            <div
                tabIndex={-1}
                role='button'
                className='talentcard-paper__content-layer'
            >
                {children}
            </div>

            {/* Top layer - overlay SVG that goes above participant image */}
            <img
                className='talentcard-paper__background-top'
                src={'/assets/rbl25/toprbl25.svg'}
                alt='Talent Card Top Layer'
            />
        </div>
  )
}

export default TalentCardPaper
